const actions = {
  getProdutosSelecionados({ commit }) {
    commit("GET_PRODUTOSSELECIONADOS");
  },

  setProdutosSelecionados({ commit }, produtosSelecionados) {
    commit("SET_PRODUTOSSELECIONADOS", produtosSelecionados);
  },

  getPautaSelecionada({ commit }) {
    commit("GET_PAUTASELECIONADA");
  },

  setPautaSelecionada({ commit }, pautaSelecionada) {
    commit("SET_PAUTASELECIONADA", pautaSelecionada);
  },

  getProdutosReferenciacao({ commit }) {
    commit("GET_PRODUTOSREFERENCIACAO");
  },

  setProdutosReferenciacao({ commit }, produtosReferenciacao) {
    commit("SET_PRODUTOSREFERENCIACAO", produtosReferenciacao);
  },
};

export default actions;
